<template>
  <div id="app" :style="style01">
    <router-view />
    <!-- <roof />
    <Base /> -->
  </div>
</template>

<script>
import store from './vuex/store.js';
// import roof from './components/roof';
// import Base from './components/Base';
export default {
  name: 'app',
  data () {
    return {
      style01:{
        width: document.documentElement.clientWidth,  //实时屏幕宽度
        height: document.documentElement.clientHeight,   //实时屏幕高度
      },
    }
  },
  store,
  methods: {
      
  },
  mounted() {//页面加载监听事件
      // window['console']['log'] = console.log() //打开默认设置
      // window['console']['log'] = function() {}; //关闭默认设置
      console.log = function() {} //关闭默认设置（语法糖）

      // const that = this
      // console.log('网站配置信息：',that.$store.state.ConfigData)
      // if(that.$store.state.ConfigData == null) {
      //     that.getConfigData(that.$route.query.$lang)//请求网站配置
      // }else {
      //     that.config = that.$store.state.ConfigData
      // } 
  },
  // components:{ roof,Base },
}
</script>

<style lang="scss">
  @import './scss/main.scss';
  @import './scss/media.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue